/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const AllIcon = ({
  className,
  style,
  color = '#938bb7',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M15.4286 0.125H0.571429C0.419876 0.125 0.274531 0.184263 0.167368 0.289752C0.0602039 0.395242 0 0.538316 0 0.6875L0 15.3125C0 15.4617 0.0602039 15.6048 0.167368 15.7102C0.274531 15.8157 0.419876 15.875 0.571429 15.875H15.4286C15.5801 15.875 15.7255 15.8157 15.8326 15.7102C15.9398 15.6048 16 15.4617 16 15.3125V0.6875C16 0.538316 15.9398 0.395242 15.8326 0.289752C15.7255 0.184263 15.5801 0.125 15.4286 0.125ZM1.14286 1.25H7.42857V7.4375H1.14286V1.25ZM1.14286 14.75V8.5625H7.42857V14.75H1.14286ZM14.8571 14.75H8.57143V8.5625H14.8571V14.75ZM14.8571 7.4375H8.57143V1.25H14.8571V7.4375Z"
        fill={color}
      />
    </svg>
  );
};
